import React from "react";
import "./Header.css";

const Header = () => {
  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div>Skill Consultant</div>

        <nav className="nav-menu">
        <span className="nav-link cursor-pointer" onClick={() => handleScroll("home")}>
            Home
          </span>
          <span className="nav-link cursor-pointer" onClick={() => handleScroll("about")}>
            About
          </span>
          <span className="nav-link cursor-pointer" onClick={() => handleScroll("services")}>
            Services
          </span>
          <span className="nav-link cursor-pointer" onClick={() => handleScroll("contact")}>
            Contact
          </span>
        </nav>
      </div>
    </header>
  );
};

export default Header;
